<template>
  <el-dialog
    class="rc-dialog"
    :title="detailTitle"
    :visible.sync="showHandleAudit.flag"
    :close-on-click-modal="false"
    @close="close"
    destroy-on-close
    width="50%"
  >
    <el-form
      :model="ruleForm"
      ref="rForm"
      label-width="125px"
      class="ruleForm"
      size="small"
    >
      <el-row>
        <el-col>
          <el-form-item
            label="审核结果："
            prop="auditSchedule"
            :rules="[{ required: true, message: '请选择审核意见' }]"
          >
            <el-radio-group
              v-model="ruleForm.auditSchedule"
              @change="auditScheduleChange(true)"
            >
              <el-radio
                v-for="(item, i) in auditScheduleAttr.slice(1, 3)"
                :key="i"
                :label="item.paramKey"
              >
                {{ item.paramValue }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="姓名：">
            {{ user.userName }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="原部门：">
            {{ user.oldDeptName }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="原单位及职务：">
            {{ user.oldPosition }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="调至学院：">
            {{ user.transFerDeptName }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="调至部门：">
            {{ user.newDeptName }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="退回原因："
            prop="auditContent"
            v-if="isUnPass"
            ref="refuse"
            :rules="[{ required: true, message: '请输入退回原因' }]"
          >
            <el-input
              type="textarea"
              placeholder="请输入退回原因"
              :row="3"
              v-model="ruleForm.auditContent"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="现任单位及职务："
            prop="auditContent"
            v-else
            ref="position"
            :rules="[{ required: true, message: '请完整填写用户现任工作单位和职务信息' }]"
          >
            <el-input
              placeholder="请完整填写用户现任工作单位和职务信息"
              v-model="ruleForm.auditContent"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="现管理主体："
            prop="leaderType"
            v-if="!isUnPass"
            ref="leaderType"
            :rules="[{ required: true, message: '请选择现管理主体' }]"
          >
            <el-select v-model="ruleForm.leaderType" placeholder="现管理主体">
              <el-option
                v-for="(item, i) in leaderTypeData"
                :key="i"
                :label="item.paramValue"
                :value="Number(item.paramKey)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="!isUnPass">
        <el-col :span="12">
          <el-form-item class="scale" label="现干部级别：" prop="cadreLevel" :rules="[{ required: true, message: '请选择现干部级别' }]">
            <el-select v-model="ruleForm.cadreLevel" placeholder="请选择现干部级别">
              <el-option v-for="item in cadreLevelData" :key="item.paramKey" :label="item.paramValue"
                :value="item.paramKey"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="!isUnPass">
        <!-- 
          干部级别选择省部级、厅局级、县处级、高校中层干部(处级)、企业中层干部(处级)时显示该字段
          其中省部级、厅局级该字段为选填项；县处级、高校中层干部（处级）、企业中层干部（处级）该字段为必填项。
         -->
        <el-col :span="12" v-if="['1', '2', '3', '6', '9'].indexOf(ruleForm.cadreLevel) > -1 && (!user.promoteSectionDate || user.promoteSectionDate == '')">
          <el-form-item 
            class="scale" 
            label="提任处级年月：" 
            prop="promoteSectionDate" 
            :rules="[{
              required: ['3', '6', '9'].indexOf(ruleForm.cadreLevel) > -1, 
              message: '提任处级年月', trigger: 'change'
            }]">
            <el-date-picker type="month" placeholder="选择日期" v-model="ruleForm.promoteSectionDate" format="yyyy-MM"
              value-format="yyyy-MM" :picker-options="monthPickerOptions"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="短信通知："
            prop="isNotice"
            :rules="[{ required: true, message: '请选择短信通知' }]"
          >
            <el-radio-group
              v-model="ruleForm.isNotice"
              @change="isNoticeChange"
            >
              <el-radio
                v-for="(item, i) in isNoticeAttr"
                :key="i"
                :label="item.paramKey"
              >
                {{ item.paramValue }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-if="isSend">
        <el-row>
          <el-col>
            <el-form-item label="消息内容：" prop="sendMessage">
              <el-input
                v-model="ruleForm.sendMessage"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="发送对象：" prop="sendPerson" ref="send">
              <span>{{ operatorName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="close" title="取消"></butn>
      <butn
        btntype="primary"
        @click="updateForm"
        title="确定"
        v-permission="'user:audit:update'"
      ></butn>
    </div>
  </el-dialog>
</template>
<script>
import butn from "@/components/button/index";
import { auditHistoryUpdate } from "@/api/moveAudit";
import { getEnums } from "@/utils/common.js";
import { getBusinessParamByTypes } from "@/api/sysParam";

export default {
  components: { butn },
  props: {
    showHandleAudit: {
      type: Object,
      default: () => {
        return {
          flag: false,
          item: {},
        };
      },
    },
  },
  data() {
    return {
      cadreLevelData: [],
      ruleForm: {
        auditSchedule: "2",
        auditContent: "",
        sendMessage: "",
        noticeType: "0",
        isNotice: true,
        sendPerson: [],
        leaderType: "",
        cadreLevel: "",
        promoteSectionDate: ""
      },
      user: {
        userName: "",
        oldDeptName: "",
        oldPosition: "",
        newDeptName: "",
      },
      auditApplyId: "",
      operatorName: "",
      detailTitle: "调动审核",
      CUFlag: false,
      isUnPass: false,
      isSend: true,
      auditScheduleAttr: [],
      sendPersonAttr: [],
      noticeTypeAttr: [],
      leaderTypeData: [],
      isNoticeAttr: [
        { paramValue: "否", paramKey: false },
        { paramValue: "是", paramKey: true },
      ],
      commonText: "您好，您申请调入到d的n",
      tPass: "审核已通过",
      tFail: "审核未通过，退回原因：（退回原因）",
      monthPickerOptions: {
        disabledDate: (time) => {
          const currentDate = new Date();
          const maxMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
          return time.getTime() >= maxMonth.getTime();
        }
      },
    };
  },
  methods: {
    getCadreLevelData(deptLevelCode) {
      getBusinessParamByTypes({types: ["CADRE_LEVEL"], deptLevelCode}).then((res) => {
        if (!res || res.code != 0) return;
        this.cadreLevelData = res.data["CADRE_LEVEL"] || [];
        // 如果新工作单位的干部级别可选范围中，存在用户当前干部级别，则默认显示当前干部级别，允许管理员修改
        const cadreLevelSet = this.cadreLevelData.map(obj => obj.paramKey);
        if (cadreLevelSet.indexOf(String(this.user.oldCadreLevel)) > -1) {
          this.ruleForm.cadreLevel = String(this.user.oldCadreLevel);
        }
      });
    },
    getLeaderTypeData(deptLevelCode) {
      getBusinessParamByTypes({types: ["USER_LEADER_TYPE"], deptLevelCode}).then((res) => {
        if (!res || res.code != 0) return;
        this.leaderTypeData = res.data["USER_LEADER_TYPE"] || [];
        const curSelect = this.leaderTypeData.filter(item => item.isSelected == 1);
        if (curSelect.length > 0) {
          this.ruleForm.leaderType = Number(curSelect[0].paramKey);
        }
      });
    },
    auditScheduleChange(flag) {
      const text = this.commonText
        .replace("n", this.user.userName)
        .replace("d", this.user.newDeptName);
      if (this.ruleForm.auditSchedule === "1") {
        this.isUnPass = true;
        if (flag) {
          this.ruleForm.auditContent = "";
        }
        this.ruleForm.sendMessage = text + this.tFail;
        this.$nextTick(() => {
          this.$refs.refuse.clearValidate();
        });
      } else if (this.ruleForm.auditSchedule === "2") {
        this.isUnPass = false;
        if (flag) {
          this.ruleForm.auditContent = "";
        }
        this.ruleForm.sendMessage = text + this.tPass;
        this.$nextTick(() => {
          this.$refs.position.clearValidate();
        });
      }
      this.$nextTick(() => {
        this.$refs.send && this.$refs.send.clearValidate();
      });
    },
    isNoticeChange() {
      this.isSend = this.ruleForm.isNotice;
      this.auditScheduleChange(false);
    },
    // 关闭
    close() {
      // 点击取消 数据重置
      this.sendPersonAttr = [];
      this.isUnPass = false;
      this.isNotice = true;
      this.isSend = true;
      this.user = {};
      this.$emit("close", false);
      this.$refs["rForm"].resetFields();
    },
    // 确定
    updateForm() {
      this.$refs["rForm"].validate((valid) => {
        if (valid) {
          if (this.ruleForm.auditSchedule === "1") {
            this.ruleForm.sendMessage =
              this.ruleForm.sendMessage.replace("（退回原因）", "") +
              this.ruleForm.auditContent;
          }
          const data = Object.assign(
            {
              auditApplyId: this.auditApplyId,
            },
            this.ruleForm
          );
          auditHistoryUpdate(data).then((res) => {
            if (res.code === 0) {
              this.$message.success(res.msg);
              this.$emit("close", true);
            }
          });
        }
      });
    },
  },
  created() {
    let _this = this;
    getEnums(
      ["AUDIT_SCHEDULE", "NOTICE_TYPE"],
      this,
      ["auditScheduleAttr", "noticeTypeAttr"],
      [false, false, false]
    );
    const item = _this.showHandleAudit.item;
    _this.auditApplyId = item.uuid;
    _this.operatorName = item.operatorName;
    _this.ruleForm.sendPerson = [item.operatorMobile];
    // if (item.transFerDeptLevelCode === "001001") {
    //   _this.ruleForm.leaderType = 2;
    // }
    _this.user = { ...item };
    _this.getLeaderTypeData(item.transFerDeptLevelCode);
    _this.getCadreLevelData(item.newDeptCode);
    _this.ruleForm.sendMessage =
      _this.commonText
        .replace("n", _this.user.userName)
        .replace("d", _this.user.newDeptName) + _this.tPass;
  },
};
</script>

<style lang="scss" scoped>
.el-dialog__body {
  padding: 20px;
  overflow-y: auto;
  max-height: 500px !important;
}
</style>

